module.exports = __webpack_public_path__ + "static/media/YM57_7.9f55ba43.jpg";